import React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import LandingMatchOdd from '../../common/LandingMatchOdd';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { getBetDescription } from '../../data/utils/getBetDescription';
import { getNumberOfColsMobile } from '../../data/utils/getNumberOfColsMobile';

function LandingMatch(props) {
    const appContext = React.useContext(AppContext);

    const match = props.match;
    let bets = null;
    if (props.firstBetOnly) {
        bets = [match.bets[0]];
    } else {
        bets = match.bets.filter(bet => bet.hasOdds);
    }

    function handleClick(){
        appContext.setHandleOpenFromPath(true);
    }

    const relativeMatchPath = useAbsolutePath(match.urlPath,null,match.urlPathSeo,true);
    const noFollow = isSeoSettingsNoFollow(match.urlPathSeoSettings);

    let team1Classes = '';
    let team2Classes = '';
    if (match.score && match.score.srv !== 0) {
        team1Classes = match.score.srv === 1 ? ' service active' : ' service';
        team2Classes = match.score.srv ===  2 ? ' service active' : ' service';
    }

    return (
        <Link to={encodeURI(relativeMatchPath) } className="event-row-container" onClick={handleClick} {...(noFollow ? {rel: 'nofollow'}:{})} >
            <div className="event-row">
                <div className="event-wrapper">
                    <div className="event-summary">
                        <div className="event-date-info-wrapper">
                            <span className="event-day">{match.date}</span>
                            <span className="event-time">{match.time}</span>
                        </div>
                        <div className="event-info-container">
                            <div className="event-competitors">
                                <span title={match.team1} className={"event-team1" + team1Classes}>
                                    {match.team1}
                                </span>
                                {match.team2?.length > 0 &&
                                    <span title={match.team2} className={"event-team2" + team2Classes}>
                                        {match.team2}
                                    </span>
                                }
                            </div>
                            <div className="event-info">
                                <div className="event-alias">
                                    <span className="event-alias-code">{match.alias}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="event-markets">
                        <div className="market-wrapper">
                            <div className="market">
                                {bets.map((bet, i) =>
                                    <React.Fragment key={bet.uniqueId}>
                                        <span className="market-bet-desc text-small ml-2">{bet.hideHandicap ? bet.aggDesc : getBetDescription(bet, true)}</span>
                                        <div className={"pick-container grid-columns-" + getNumberOfColsMobile(bet.odds.length)}>
                                            {bet.odds.map(odd =>
                                                <LandingMatchOdd key={`${odd.betData.id}_${odd.betData.handicap}_${odd.id}`} {...odd} matchData={match} />
                                            )}
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                            {match.avvRef != null ?
                                <span className="more-odds"><b>+</b></span>
                                :
                                <span className="more-odds">+{match.plus}</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
}

const LandingMatchMemo = React.memo(LandingMatch, (prevProps, nextProps) => {
    if (prevProps.match.id === nextProps.match.id && prevProps.aggregata === nextProps.aggregata) {
      return true;
    }
    return false;
});

export default LandingMatchMemo;